// extracted by mini-css-extract-plugin
export var text = "_bl-0";